const t = (r, c) => {
  const e = r % 1 === 0 ? 0 : 2;
  return Intl.NumberFormat(c.locale, {
    currency: c.code || "USD",
    maximumFractionDigits: e,
    minimumFractionDigits: e,
    style: "currency"
  }).format(r);
};
export {
  t as default
};
